import script from "./UpTiTarifa.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpTiTarifa.vue?vue&type=script&lang=ts&setup=true"

import "./UpTiTarifa.vue?vue&type=style&index=0&id=745a6c62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745a6c62"]])

export default __exports__